{
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.0.2",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 90,
	"w": 300,
	"h": 300,
	"nm": "Loading-circle-300x300_round-cap",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "white_end",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": { "a": 0, "k": 0, "ix": 1 },
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 45,
										"s": [0.2]
									},
									{ "t": 89, "s": [99] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 45,
										"s": [36]
									},
									{ "t": 89, "s": [12] }
								],
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 45,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "white_begin",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [1]
									},
									{ "t": 44, "s": [99.8] }
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.833], "y": [1] },
										"o": { "x": [0.167], "y": [0] },
										"t": 0,
										"s": [100]
									},
									{ "t": 44, "s": [100] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [12]
									},
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 44,
										"s": [36]
									},
									{ "t": 89, "s": [12] }
								],
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 45,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "red 2",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [1]
									},
									{ "t": 51, "s": [0] }
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 51,
										"s": [0.2]
									},
									{ "t": 89, "s": [99.5] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.890196084976, 0.137254908681,
									0.1254902035, 1
								],
								"ix": 3
							},
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [8]
									},
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 44,
										"s": [32]
									},
									{ "t": 89, "s": [8] }
								],
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 51,
			"op": 90,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "red",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [1]
									},
									{ "t": 50, "s": [100] }
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 50,
										"s": [99.8]
									},
									{ "t": 89, "s": [99.5] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.890196084976, 0.137254908681,
									0.1254902035, 1
								],
								"ix": 3
							},
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [8]
									},
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 44,
										"s": [32]
									},
									{ "t": 89, "s": [8] }
								],
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 51,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "BG",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": { "a": 0, "k": 0, "ix": 1 },
							"e": { "a": 0, "k": 100, "ix": 2 },
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.133333340287, 0.133333340287,
									0.133333340287, 1
								],
								"ix": 3
							},
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 0,
										"s": [10]
									},
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 44,
										"s": [34]
									},
									{ "t": 89, "s": [10] }
								],
								"ix": 5
							},
							"lc": 1,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 90,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
